import React from "react";

function Heic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      height="45"
      width="45"
      version="1.1"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="#E2E5E7"
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
      />
      <path
        fill="#B0B7BD"
        d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
      />
      <polygon fill="#CAD1D8" points="480,224 384,128 480,128" />
      <path
        fill="#2D6CCA"
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z"
      />
      <text
        x="208"
        y="360"
        fill="#FFFFFF"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="800"
        fontSize="105"
        letterSpacing="6"
        textAnchor="middle"
      >
        HEIC
      </text>
    </svg>
  );
}

export default Heic;
